import i18n from '@/plugins/i18n'
import axios from 'axios'
import socialLinks from '../constants/socialLinks'

export default {
  namespaced: true,
  state: {
    clientLocation: 'global',
    languages: [],
    showPartnerBlock: ['ru'],
    socials: ['vk', 'telegram', 'youtube', 'instagram', 'facebook'],
    allowedLocales: {
      ru: ['ru', 'kg', 'md', 'tj', 'uz', 'am', 'ge', 'kz'],
      ua: ['ua'],
      cy: ['cy', 'global', 'am', 'fr', 'ge', 'kz', 'kg', 'md', 'ko', 'sr', 'tj', 'ar', 'us', 'uz', 'by', 'ca', 'gb', 'ru']
    },
    socialExcludes: {
      vk: ['global', 'am', 'cy', 'fr', 'ge', 'kz', 'kg', 'md', 'ko', 'sr', 'tr', 'tj', 'ar', 'us', 'uz', 'by', 'ca', 'gb'],
      telegram: ['global', 'am', 'cy', 'fr', 'ge', 'kz', 'kg', 'md', 'ko', 'sr', 'tr', 'tj', 'ar', 'us', 'uz', 'by', 'ca', 'gb'],
      instagram: ['ru', 'ua'],
      facebook: ['ru'],
      youtube: ['ar']
    },
    menu: [
      { title: i18n.t('products.title'), to: { name: 'home', hash: '#products' } },
      { title: i18n.t('riders.title'), to: { name: 'home', hash: '#riders' } },
      { title: i18n.t('fighters.title'), to: { name: 'home', hash: '#fighters' } },
      { title: i18n.t('news.title'), to: { name: 'home', hash: '#news' } },
      { title: i18n.t('faq.title'), to: { name: 'home', hash: '#faq' } }
    ]
  },
  getters: {
    menu: (state, _, rootState) => {
      const siteVersionCode = rootState.siteVersions.item?.code

      return [
        ...(
          state.showPartnerBlock.includes(siteVersionCode)
            ? [{ title: 'toxi$', to: { name: 'home', hash: '#toxis' } }]
            : []
        ),
        ...state.menu
      ]
    },
    getSocialLinks: (state, _, rootState) => {
      const siteVersion = rootState.siteVersions.item?.code || 'global'
      const allowedSocials = state.socials.filter(el => !(state.socialExcludes[el] || []).includes(siteVersion))

      return allowedSocials.map(el => ({
        code: el,
        title: i18n.t(`socials.${el}.title`),
        text: i18n.t(`socials.${el}.text`),
        ...(socialLinks[el][siteVersion] || socialLinks[el]['global'])
      }))
    }
  },
  mutations: {
    SET_LANGUAGES (state, items) {
      state.languages = items.map(value => ({
        lang: value,
        title: value
      }))
    },
    SET_CLIENT_LOCATION (state, item) {
      state.clientLocation = item
    }
  },
  actions: {
    async getClientLocation ({ commit }) {
      let clientLocation = 'global'
      try {
        const { data } = await axios.get(process.env.VUE_APP_GEO_IP_URL)
        clientLocation = data.country.toLowerCase()
      } catch (error) { }

      commit('SET_CLIENT_LOCATION', clientLocation)
    }
  }
}
